import { render, staticRenderFns } from "./AdminCompany.vue?vue&type=template&id=00faed14&"
import script from "./AdminCompany.vue?vue&type=script&lang=js&"
export * from "./AdminCompany.vue?vue&type=script&lang=js&"
import style0 from "./AdminCompany.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports